import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>404 — Page non trouvée</h1>
      <p>La page que vous recherchez n'existe pas.</p>
      <p>
        <Link to="/">Retour à l'accueil</Link>
      </p>
    </div>
  );
}
